
import GwContentTemplate from '~/patterns/templates/content';
import FlexibleSection from '~/patterns/organisms/_flexible-section/flexible-section';
import GwBackground from '~/patterns/atoms/background/background.vue';
import GwCourseInfo from '~/patterns/organisms/course-info/course-info.vue';
import GwCategory from '~/patterns/atoms/category/category.vue';
import GwPageMeta from '~/patterns/molecules/page-meta/page-meta.vue';

import GwPageContainer from '~/patterns/molecules/page-container/page-container.vue';
import GwPageTitle from '~/patterns/molecules/page-title/page-title.vue';
import GwPageIntro from '~/patterns/molecules/page-intro/page-intro.vue';

import getCoursePage from '~/graphql/queries/getCoursePage.graphql';
import seo from '~/mixins/seo';
import GwError from '~/patterns/molecules/error';

export default {
    components: {
        GwContentTemplate,
        GwBackground,
        GwCourseInfo,
        GwCategory,
        FlexibleSection,
        GwPageContainer,
        GwPageIntro,
        GwPageMeta,
        GwPageTitle,
        GwError,
    },
    mixins: [seo],
    data() {
        return {
            entry: null,
            notFound: false
        };
    },
    async fetch() {
        const site = this.$config.appMultisiteHandle,
            uri = this.$route.path.replace(/^\/|\/$/, ''),
            { data } = await this.$gql.executeQuery(
                getCoursePage,
                { site, uri }
            );

        if (data && data.entry) {
            this.entry = data.entry;
        } else {
            this.notFound = true;
            if (process.server) {
                this.$nuxt.context.res.statusCode = 404;
            }
        }
    },
    nuxtI18n: {
        paths: {
            en: '/courses/:category/:slug',
            in: '/courses/:category/:slug',
            nl: '/trainingen/:category/:slug',
            fr: '/formations/:category/:slug',
            de: '/trainings/:category/:slug',
            'en-Highberg': '/courses/:category/:slug',
            'nl-Highberg': '/trainingen/:category/:slug',
            'de-Highberg': '/trainings/:category/:slug',
        }
    }
};
